export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M2.016 12.016a.75.75 0 0 1 .75-.75h16.658l-1.548-1.549a.75.75 0 0 1 1.06-1.06l2.829 2.829.052.056a.75.75 0 0 1-.052 1.004l-2.828 2.829a.75.75 0 0 1-1.061-1.061l1.548-1.548H2.766a.75.75 0 0 1-.75-.75Z"/>
</svg>
`;
